const subscribers = [];

export function subscribeMetrics(callback) {
  subscribers.push(callback);
}

export function unsubscribeMetrics(callback) {
  subscribers.splice(
    subscribers.findIndex((c) => c === callback),
    1,
  );
}

export function submitMetric(action) {
  subscribers.forEach((subscriber) => subscriber(action));
}

export function metricsDataFromState({ pageName, ...state }) {
  const metricsData = {
    currentPage: pageName,
    subPage: state[pageName].subPage || null,
  };

  if (state.questionnaire && state.sessionInfo.questions) {
    metricsData.questionnaire = {
      questionsAnswered: Object.keys(state.questionnaire.answers || {}).map(
        (id) => {
          const [question, index] = state.sessionInfo.questions
            .map((value, i) => [value, i + 1])
            .find(([{ id: questionId }]) => questionId === id);
          return {
            index,
            key: question.key,
          };
        },
      ),
    };
  }

  if (state.clinicForm) {
    metricsData.clinicForm = {
      siteIsSelected: Boolean(state.clinicForm.selectedSite),
    };
  }

  if (state.contactDetails) {
    metricsData.contactDetailsForm = {
      enteredFields: Object.entries(state.contactDetails.fieldValues || {})
        .filter((entry) => entry[1].value)
        .map(([key]) => key),
      fieldsWithErrors: Object.entries(state.contactDetails.fieldValues || {})
        .filter((entry) => entry[1].errors && entry[1].errors.length)
        .map(([key]) => key),
      hasConsented: state.contactDetails.consented,
    };
  }

  return metricsData;
}
